 import React from "react";
import DashBoard from "./components.js/DashBoard";

function App() {
  return (
    <div style={{ padding: 20 }}>
      <DashBoard />
    </div>
  );
}

export default App;
